import { Box, Typography, Button, Divider } from "@material-ui/core";
import { X } from "react-feather"; // replace if needed
import myTeamBillingsPageStyles from "./MyTeamBillingsPageStyles";
import {
  Diamond,
  Download,
  DownloadSimple,
  SketchLogo,
  Sparkle,
  Stack,
  User,
} from "phosphor-react";

const InvoiceSidePanel = ({ handleClose, invoiceDetails }) => {
  const classes = myTeamBillingsPageStyles();

const labelIcons = {
  "Plan Type": SketchLogo,
  "Team Seats": User,
  Storage: Stack,
  "AI Credits": Sparkle,
};

  return (
    <Box
      sx={{
        position: "absolute",
        right: 0,
        top: "0.31px",
        width: "524px",
        height: "100%",
        backgroundColor: "#1B1D28",
        border: "1px solid #606479",
        boxShadow: "-10px 0px 30px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        zIndex: 3,
        color: "#F9F9F9",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          padding: "24px",
          borderBottom: "1px solid #252A38",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#F9F9F9",
                }}
              >
                Monthly Invoice
              </Typography>

              <Box>
                <Typography
                  className={
                    invoiceDetails?.status === "paid"
                      ? classes.paidStatus
                      : classes.pendingStatus
                  }
                >
                  {invoiceDetails?.status}
                </Typography>
              </Box>
            </Box>

            <Typography
              style={{
                fontSize: "14px",
                color: "#B1B5C9",
                marginTop: "10px ",
              }}
            >
              Invoice dated{" "}
              {invoiceDetails?.created_at &&
                new Date(invoiceDetails?.created_at).toLocaleDateString(
                  "en-GB",
                  {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  },
                )}
            </Typography>
          </Box>

          <Button onClick={handleClose}>
            <X color="#F9F9F9" />
          </Button>
        </Box>

        <Box sx={{ display: "flex", gap: "20px", marginTop: "16px" }}>
          <Box sx={{ flex: 1 }}>
            <Typography style={{ color: "#B1B5C9", fontSize: "14px" }}>
              Invoice Number
            </Typography>
            <Typography sx={{ color: "#F9F9F9", fontSize: "14px" }}>
              {invoiceDetails?.invoice_id}
            </Typography>
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography style={{ color: "#B1B5C9", fontSize: "14px" }}>
              Payment Method
            </Typography>
            <Typography sx={{ color: "#F9F9F9", fontSize: "14px" }}>
              {invoiceDetails?.payment_method || "N/A"}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Plan Details */}
      <Box sx={{ padding: "24px", borderBottom: "1px solid #252A38" }}>
        {[
          ["Plan Type", invoiceDetails?.tier || "N/A"],
          ["Team Seats", invoiceDetails?.seats || "N/A"],
          ["Storage", invoiceDetails?.storage || "N/A"],
          ["AI Credits", invoiceDetails?.ai_credits || "N/A"],
        ].map(([label, value]) => {
          const Icon = labelIcons[label];

          return (
            <Box
              key={label}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              {/* Label + Icon */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  width: "100%",
                }}
              >
                {Icon && <Icon size={16} color="#B1B5C9" />}
                <Typography
                  style={{
                    color: "#B1B5C9",
                    fontSize: "14px",
                  }}
                >
                  {label}
                </Typography>
              </Box>

              {/* Value */}
              <Typography
                style={{
                  color: "#F9F9F9",
                  fontSize: "14px",
                  textAlign: "start",
                  width: "100%",
                }}
              >
                {value}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* Price Breakdown */}
      <Box sx={{ padding: "24px", borderBottom: "1px solid #252A38" }}>
        {[
          [
            "Plan Fee",
            `${invoiceDetails?.currency === "inr" ? "₹" : "$" + (Number(invoiceDetails?.subtotal) / 100)?.toFixed(2)}`,
          ],
          [
            "Additional Fees",
            `${invoiceDetails?.currency === "inr" ? "₹" : "$" + "0.00"}`,
          ],
        ].map(([label, value]) => (
          <Box
            key={label}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "8px",
            }}
          >
            <Typography
              style={{
                color: "#B1B5C9",
                fontSize: "14px",
                textAlign: "start",
                width: "100%",
              }}
            >
              {label}
            </Typography>
            <Typography
              style={{
                color: "#B1B5C9",
                fontSize: "14px",
                textAlign: "start",
                width: "100%",
              }}
            >
              {value}
            </Typography>
          </Box>
        ))}

        <Divider sx={{ backgroundColor: "#252A38", margin: "12px 0" }} />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            style={{
              color: "#ECECEC",
              fontSize: "14px",
              textAlign: "start",
              width: "100%",
            }}
          >
            Total
          </Typography>
          <Typography
            style={{
              color: "#F9F9F9",
              fontWeight: 500,
              fontSize: "14px",
              textAlign: "start",
              width: "100%",
            }}
          >
            {invoiceDetails?.currency === "inr"
              ? "₹"
              : "$" + (Number(invoiceDetails?.subtotal) / 100)?.toFixed(2)}
          </Typography>
        </Box>
      </Box>

      {/* Download Button */}
      <Box sx={{ padding: "24px" }}>
        <Button
          onClick={() => window.open(invoiceDetails?.invoice_download_url)}
          startIcon={<DownloadSimple />}
          fullWidth
          style={{
            height: "37px",
            background: "rgba(108, 101, 217, 0.16)",
            borderRadius: "10px",
            textTransform: "none",
            color: "#9992FF",
            fontSize: "14px",
            gap: "10px",
            "&:hover": {
              background: "rgba(108, 101, 217, 0.2)",
            },
          }}
        >
          Download Invoice
        </Button>
      </Box>
    </Box>
  );
};

export default InvoiceSidePanel;
